import React from 'react';

export interface SelectFormatPaneProps {}

export default function SelectFormatPane(props: SelectFormatPaneProps): JSX.Element {
  return (
    <div>
      <h3>Format</h3>
      <p>Select the antibody format you want to create.</p>
      <p>Options:</p>
      <ul>
        <li>IgG monospecific</li>
        <li>Fab</li>
      </ul>

      <h3>Variable domains</h3>
      <p>Select the starting entity type for the variable domains.</p>
      <ul>
        <li>DNA domains</li>
      </ul>

      <h3>Additional nested entities</h3>
      <p>Select the additional nested entities you'd like to create.</p>
      <ul>
        <li>AA domains</li>
        <li>AA chains</li>
      </ul>
    </div>
  );
}
